import { jsx } from 'react/jsx-runtime';
import { memo, useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import { Scrollbar } from 'react-scrollbars-custom';
import 'date-fns/format';
import event from '../../utils/events.js';
import { gridHorizontalScrollEvent } from '../Table/scrollUtils.js';

const StyledScrollbar = styled(Scrollbar, {
    shouldForwardProp: (prop) => !['totalStickyColumnSize'].includes(prop),
}) `
  ${({ theme, totalStickyColumnSize, rtl }) => `
    .ScrollbarsCustom-Track {
      background-color: transparent !important;
      height: 14px !important;
      ${rtl ? `` : `left: ${totalStickyColumnSize}px !important`};
      width: calc(100% - 14px) !important;
    }
    
    .ScrollbarsCustom-Thumb {
      transition: background-color ${theme.transitions.duration.fast} linear !important;
      border-radius: 9999px !important;
      min-width: 24px !important;
      background-color: ${theme.palette.N30.main} !important;
      border: 4px solid transparent !important;
      background-clip: padding-box !important;
    
      &:hover {
        background-color: ${theme.palette.primary.dark} !important;
      }
    }
  `}
`;
const onScrollbarScroll = ({ scrollLeft }) => {
    event.emit(gridHorizontalScrollEvent, scrollLeft, 'scrollbar');
};
const CustomScrollbar = memo(({ rtl, width, totalStickyColumnSize, totalColumnWidth }) => {
    const [scrollLeft, setScrollLeft] = useState(0);
    useEffect(() => {
        event.on('CustomScrollbar', gridHorizontalScrollEvent, (scrollLeft, origin) => {
            if (origin === 'scrollbar')
                return;
            return setScrollLeft(scrollLeft);
        });
        return () => {
            event.off('CustomScrollbar', gridHorizontalScrollEvent);
        };
    }, []);
    return (jsx(StyledScrollbar, Object.assign({ totalStickyColumnSize: totalStickyColumnSize, rtl: rtl, style: { height: 10, width: rtl ? width : width - totalStickyColumnSize }, onScroll: onScrollbarScroll, scrollLeft: scrollLeft }, { children: jsx("div", Object.assign({ style: { width: rtl ? totalColumnWidth : totalColumnWidth - totalStickyColumnSize + 50 } }, { children: "s" })) })));
});
CustomScrollbar.displayName = 'CustomScrollbar';

export { CustomScrollbar as default };
//# sourceMappingURL=CustomScrollbar.js.map
